
import Vue from "vue"

export default Vue.extend({
  name: "EventsContestantsCreateDialogMemberSelectItem",
  props: {
    member: { type: Object, required: true }
  }
})
